import moment from 'moment';
import { authContext } from './configAdal';
import bidPeriodsJson from '../data/bidPeriods.json';
import _each from 'lodash/each';
import _some from 'lodash/some';

const user = authContext.getCachedUser();

const commonFunctions = {
    formatDate_DateTime(date) {
        if (date == null || date === '') {
            return '';
          }
        return moment(date).format('MM/DD/YY hh:mm A');
    },
    formatDate_DateTime24(date) {
        if (date == null || date === '') {
          return '';
        }
      return moment(date).format('MM/DD/YY HH:mm');
    },
    formatDate_Date(date) {
        if (date == null || date === '') {
            return '';
          }
        return moment(date).format('MM/DD/YY');
    },
    formatDate_MonthDay(date) {
        if (date == null || date === '') {
            return '';
          }
        return moment(date).format('MM/DD');
    },
    formatDate_ShortMonthDay(date) {
        if (date == null || date === '') {
            return '';
          }
        return moment(date).format('M/DD');
    },
    formatMonth(number) {
      switch (number) {
        case '1': case 1 : return 'January';
        case '2': case 2: return 'February';
        case '3': case 3: return 'March';
        case '4': case 4: return 'April';
        case '5': case 5: return 'May';
        case '6': case 6: return 'June';
        case '7': case 7: return 'July';
        case '8': case 8: return 'August';
        case '9': case 9: return 'September';
        case '10': case 10: return 'October';
        case '11': case 11: return 'November';
        case '12': case 12: return 'December';
        default: return null;
      }
    },
    getUserName() {
      return user.profile['display-name'];
    },
    getUserEmployeeId() {
      return user.profile['employee-id'];
    },
    calculateNumberOfDays(startDate, inclusiveEndDate) {
      const momentStartDate = moment(startDate);
      const momentEndDate = moment(inclusiveEndDate);
      const diff = momentEndDate.diff(momentStartDate, 'days') + 1;
      return diff;
    },
    isWithinBidPeriod(startDate, inclusiveEndDate, year) {
        // returns TRUE if dates given fall within any of the bid periods
        var bidPeriods = [];
        //TODO do not use this bidPeriodsJson, point to prod CSS instead
        _each(bidPeriodsJson, function(i){
            let a = i.start + year;
            let b = i.end + year;
            bidPeriods.push({"start": a, "end": b});
        });
        return _some(bidPeriods, function(i){ 
          return (moment(startDate).isSameOrAfter(i.start) && moment(inclusiveEndDate).isSameOrBefore(i.end))
        });
    }
};

export default commonFunctions;